import React, { useMemo } from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useColorMode, useColors } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import lightLogo from "../../assets/logos/light/wellenzahl-logo-light-text.svg";
import darkLogo from "../../assets/logos/dark/wellenzahl-logo-dark-text.svg";

const Topbar = () => {
    const theme = useTheme();
    const { toggleColorMode } = useColorMode();
    const colors = useColors();

    // Memoisierung der Logo-Auswahl basierend auf dem Theme-Modus
    const logoSrc = useMemo(
        () => (theme.palette.mode === "dark" ? lightLogo : darkLogo),
        [theme.palette.mode]
    );

    // Memoisierung des Icons für den Farbschema-Wechsel
    const ModeIcon = useMemo(
        () => (theme.palette.mode === "dark" ? DarkModeOutlinedIcon : LightModeOutlinedIcon),
        [theme.palette.mode]
    );

    // Memoisierung der Styles für die Topbar
    const topbarStyle = useMemo(
        () => ({ borderBottom: '1px solid #efefef' }),
        []
    );

    return (
        <Box display="flex" p={2} sx={topbarStyle}>
            {/* Logo */}
            <Box flex="1" display="flex" justifyContent="flex-start" alignItems="center">
                <img src={logoSrc} className="app-logo-topbar" alt="Wellenzahl Logo mit Text" />
            </Box>

            {/* Zentrumstext */}
            <Box flex="1" display="flex" justifyContent="center" alignItems="center">
                <Typography variant="h3" color={colors.grey[100]}>
                    IoT-Plattform
                </Typography>
            </Box>

            {/* Icons */}
            <Box flex="1" display="flex" justifyContent="flex-end" alignItems="center">
                <IconButton onClick={toggleColorMode}>
                    <ModeIcon />
                </IconButton>
                <IconButton>
                    <SettingsOutlinedIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default Topbar;